import React, { Component } from 'react';
import ReportHeader from '../../ReportHeader'
import ReportHeader2 from '../../ReportHeader2'
import ReportHeader3 from '../../ReportHeader3'
import Section from '../../ReportSection/index'
import SuccessStatus from '../../SuccessStatus/index'
import SubtestSummary from '../../SubtestSummary/index'
import ErrorTable from '../ErrorTableEnterprise'
import T from 'i18n-react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import _ from 'lodash'
import { compose } from 'recompose';

class GenericTestSection extends Component {

  render() {
    const { error, testId, result, subtestDetails } = this.props
    const hasErrorData = error && error.length > 0
    const hasSubtestDetails = subtestDetails && subtestDetails.length > 0

    return (
      <Section>
        <ReportHeader
          title={T.translate(`containers.project.nvqualSection.test.${testId}`)}
        />
        <Section>
          <ReportHeader2 title={'Summary'} />
          <Section>
            <SuccessStatus result={result} />
            {hasSubtestDetails &&
              <div>
                <ReportHeader3 title={'Subtest Summary'} />
                <SubtestSummary subTestResults={subtestDetails} />
              </div>}

            {hasErrorData &&
              <React.Fragment>
                <ReportHeader3 title={'Errors'} />
                <ErrorTable errors={error} />
              </React.Fragment>
            }
          </Section>
        </Section>
      </Section>
    );
  }
}

const withStyles = CSSModules(styles);
const enhance = compose(withStyles);
export default enhance(GenericTestSection);